"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "useAuthState", {
  enumerable: true,
  get: function get() {
    return _useAuthState["default"];
  }
});
require("cross-fetch/polyfill");
var _loader = _interopRequireDefault(require("./loader"));
var _useAuthState = _interopRequireDefault(require("./hooks/use-auth-state"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = _loader["default"];